export default __webpack_public_path__ + "static/media/internBlue.49509e99.svg";